'use strict';
import {runInjector} from '../_libs/angular-utils/index';
import {FeedList} from './components/FeedList';
import {UserFeedList} from './components/UserFeedList';
import {ActivityFeedDomainProvider} from './domain/ActivityFeedDomain';
import {ActivityFeedTypeDomainProvider} from './domain/ActivityFeedTypeDomain';
import {FeedEntryService} from './services/FeedEntryService';


const angular = require('angular');

module.exports = angular
  .module('app.activity-feed', [])

  .provider('ActivityFeedDomain', ActivityFeedDomainProvider)
  .provider('ActivityFeedTypeDomain', ActivityFeedTypeDomainProvider)

  .value('FeedListComponent', FeedList)
  .value('UserFeedList', UserFeedList)
  .run(runInjector(FeedList))
  .service('feedEntryService', FeedEntryService)
;



// WEBPACK FOOTER //
// ./src/js/activity-feed/index.js